import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface KpiCardProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  helper?: React.ReactNode;
}

export function KpiCard({ label, value, icon, helper, className, ...props }: KpiCardProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between rounded-md border border-muted/40 bg-surface p-4 shadow-sm",
        className,
      )}
      {...props}
    >
      <div>
        <div className="text-sm text-muted">{label}</div>
        <div className="text-2xl font-bold leading-none">{value}</div>
        {helper && <div className="mt-1 text-xs text-muted">{helper}</div>}
      </div>
      {icon && <div className="text-accent">{icon}</div>}
    </div>
  );
}

export default KpiCard;
